import energy_usage from "../../images/homepage/Energy_Usage.png";
import "../../css/common.module.css";

export default function EnergyUsage() {
  return (
    <div className="container mt-6">
      <div className="row block-row">
        <div class="col justify-content-start pt-2">
          <h5 class="text-start ps-6 card-header fw-semibold block-title">
           Energy Usage
          </h5>
          <p className="fs-5"> </p>
	      <span class="float-start"> 
	      <img className="img-fluid" src={energy_usage} 
	           style={{
	            paddingLeft: "0px",
	            paddingRight: "0px",
	            height: "450px",
	          }}
	          >
	      </img></span>
	    </div>
      </div>
    </div>
  );
}
